export default __webpack_public_path__ + "9a3fa183be5ba2b58a45d907342f7de5.png";